import { BooleanCons, StringConst } from 'src/app/constants/const';

export class SpinnerConfig {
    name: string;
    status: boolean;
    constructor(){
        this.name = StringConst.empty;
        this.status = BooleanCons.false;
    }
}
